<template>
  <div id="app">
    <!-- <div v-if="loading == false"> -->
    <keep-alive v-if="$route.meta.keepAlive">
      <router-view></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>

    <div    @click="showForm"   v-if="isShow" class="flex flex-direction flex-center" style="cursor: pointer;border-radius: 5px;position: fixed; right: 20px; top: 70%; z-index: 1000;background: #C2281B;width: 94px;height: 114px;">

      <img src="./assets/img/order.png" alt="" />
      <span style="color:#fff">调查问卷</span>
    </div>
    <el-dialog :show-close="false" width="1000px" center :visible.sync="dialogFormVisible">
      <div slot="title" class="flex align-center justify-between ">
        <span style="font-size: 24px; color: #3d3d3d; font-weight: bold"
          >调查问卷</span
        >
        <img style="cursor: pointer;" @click="dialogFormVisible = false" src="./assets/img/close.png" alt="" />
      </div>
      <div class="flex flex-direction" style="align-items: start">
        <span style="font-size: 24px; color: #000"
          >1、是否推荐采购本数据库产品？<span style="color:red">*</span></span
        >
        <div class="flex" style="margin: 28px 40px 33px">
          <div @click="setItemCheck('是')" style="cursor: pointer;" class="flex flex-center">
            <img v-if="radio==='是'" src="./assets/img/radio_sel.png" alt="" />
            <img v-else src="./assets/img/radio.png" alt="" />
            <span style="font-size: 26px; color: #1a1a1a; margin-left: 18px"
              >是</span
            >
          </div>
          <div @click="setItemCheck('否')" class="flex flex-center" style="cursor: pointer;margin-left: 78px;">
            <img v-if="radio==='否'" src="./assets/img/radio_sel.png" alt="" />
            <img v-else src="./assets/img/radio.png" alt="" />
            <span style="font-size: 26px; color: #1a1a1a; margin-left: 18px"
              >否</span
            >
          </div>
        </div>

        <span style="font-size: 24px; color: #000;"
          >2、请留下您对本数据库产品的宝贵意见和建议。</span
        >

        <el-input
          type="textarea"
          placeholder="请输入..."
          v-model="textarea"
          size="medium"
          style="margin-top: 30px"
          maxlength="100"
          rows="4"
          show-word-limit
        >
        </el-input>
      </div>
      <div slot="footer" class="dialog-footer">

        <el-button style="width: 100%;" round size="medium" type="primary" @click="toUpload"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import common from '@/utils/common.js'
import md5 from 'js-md5'
import { postRequestWx, getRequestWx } from './utils/utilsWx'
import { mapState } from 'vuex'
import { Message } from 'element-ui'
export default {
  name: 'App',
  data () {
    return {
      loading: true,
      textarea: '',
      radio: '是',
      isShow: false,
      dialogFormVisible: false
    }
  },
  created () {
    this.isToken()
  },
  computed: {
    ...mapState({
      userBase: (state) => state.user.userBase
    })
  },
  watch: {
    userBase: {
      handler (val, oldVal) {
        if (val !== null) {
          this.feedbackRecord()
        } else {
          this.isShow = false
        }
      },
      immediate: true
    }
  },
  mounted () {},
  methods: {
    setItemCheck (type) {
      this.radio = type
    },
    feedbackRecord () {
      getRequestWx('https://wxmini7.api.bjadks.com/FeedbackRecord/IsShow', {
        comId: this.userBase.ComId
      }).then((data) => {
        if (data.IsSuccess) {
          this.isShow = data.Data
        }
      })
    },
    toUpload () {
      const time = new Date().getTime()
      const string = time + 'feedBack@Adks1234'

      if (this.textarea) {
        const form = {
          data: [
            {
              questionId: 1,
              answer: this.radio,
              userId: this.userBase.UserId,
              source: 10,
              comId: this.userBase.ComId
            },
            {
              questionId: 2,
              answer: this.textarea,
              userId: this.userBase.UserId,
              source: 10,
              comId: this.userBase.ComId
            }
          ]
        }
        // 成功
        const md5String = md5(JSON.stringify(form) + string)
        postRequestWx(
          'https://wxmini7.api.bjadks.com/FeedbackRecord/SubmitFeedback',
          form,
          md5String.toUpperCase(),
          time
        ).then((data) => {
          if (data.IsSuccess) {
            Message.success({ message: '提交成功' })
          }
          this.dialogFormVisible = false
        })
      } else {
        const form = {
          data: [
            {
              questionId: 1,
              answer: this.radio,
              userId: this.userBase.UserId,
              source: 10,
              comId: this.userBase.ComId
            }
          ]
        }
        const md5String = md5(JSON.stringify(form) + string)

        postRequestWx(
          'https://wxmini7.api.bjadks.com/FeedbackRecord/SubmitFeedback',
          form,
          md5String.toUpperCase(),
          time
        ).then((data) => {
          if (data.IsSuccess) {
            Message.success({ message: '提交成功' })
          }
          this.dialogFormVisible = false
        })
      }
    },
    isToken () {
      if (window.location.href.indexOf('/black') != -1) {
        return
      }
      if (window.location.href.indexOf('/company') != -1) {
        return
      }
      var token = common.getCookie('utoken')
      if (token == '') {
        var httpurl = localStorage.getItem('islogin_httpurl') || ''

        if (httpurl == '') {
          localStorage.setItem('islogin_httpurl', window.location.href)

          this.$router.replace({
            name: 'black',
            params: {
              isfirst: 'first',
              states: 'auto'
            }
          })
        }
      } else {
        // localStorage.removeItem('islogin_httpurl')
      }
    },
    showForm () {
      this.textarea = ''
      this.radio = '是'
      this.dialogFormVisible = true
    },
    getQueryString (name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      var r = window.location.search.substr(1).match(reg)
      if (r != null) return unescape(r[2])
      return ''
    }
  }
}
</script>

<style>
.el-dialog__footer {
    padding: 10px 40px 40px;

}
.el-button.is-round {
    border-radius: 40px;

}
.el-button--medium.is-round {
    padding: 15px 20px;
}
.el-button--primary {
    color: #FFF;
    background-color: #1862E5;
    border-color: #1862E5;
}
.el-button--medium {
    padding: 15px 20px;
    font-size: 20px;

}
.el-dialog__header {
  padding: 49px 40px 10px;
}
.el-dialog--center .el-dialog__body {
  text-align: initial;
  padding: 25px 40px 30px;
}

.el-textarea__inner:focus {

    border-color: #1a1a1a;

}

.el-textarea__inner {
    color: #000;
    font-size: 20px;
    border: 1px solid #D9D9D9;

}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #666;
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue